import Vue from 'vue'
import App from './App.vue'
import './plugins/element'
import router from './router/index'
import store from './store/index'

// 全局样式表
import "./assets/css/base.css"
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/element.css'
import Element from 'element-ui'
Vue.use(Element, {
  size: 'small', // set element-ui default size
  // i18n: (key, value) => i18n.t(key, value)
})
import { request } from "./network/request";
import mongolRequest from "./network/mongolRequest";

Vue.prototype.$http = mongolRequest // ajax请求方法

Vue.prototype.$request = request;

router.afterEach(( to, from, next ) => {
  setTimeout(()=>{
    // 此处粘贴百度统计复制过来的代码
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26344108755402877a44ccb0859ac85d";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  },0);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
